export default __webpack_public_path__ + "static/media/day.a6c645b7.svg";